import controllers from "venuescanner-js/services/controllers";

export async function getTagByName(name) {
  const response = await controllers.tags.getTagByName.get({
    name,
  });

  const {
    data: { tag },
  } = response;

  return tag;
}
